import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from "react-intl";
import { urlLocations } from "routes/urlLocations";
import Styled from './styled/StyledAutorizeLayout.js';

export default ({ children }) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        const storage = localStorage.getItem("storageTyp");
        const jwt = window[storage]?.getItem('jwt');
        jwt && navigate(urlLocations.dashboard);
    }, [navigate]);

    return (
        <Styled.Layout>
            <Styled.LeftBlock>
                <Styled.Img></Styled.Img>
                <Styled.Title>
                    <FormattedMessage id="MainPage.Title" />
                </Styled.Title>
                <Styled.IntoBlock>
                    <Styled.IntoTxt>
                        <FormattedMessage id="MainPage.Description" />
                    </Styled.IntoTxt>
                </Styled.IntoBlock>
            </Styled.LeftBlock>

            <Styled.RightBlock>
                { children }
            </Styled.RightBlock>
        </Styled.Layout>
    )
};

